<template>
    <rkm-area
        background-color="secondary"
        closed
        header-prefix-icon="check-circle"
        title="Finalização do atendimento"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.atendimentoTipo.nome"
                    label="Tipo de atendimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.saudeBucal.consultaTipo.descricao"
                    label="Tipo de consulta"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.atendimentoCompartilhadoUsuario.cns
                        ? `${item.finalizacao.atendimentoCompartilhadoUsuario.nome} - ${item.finalizacao.atendimentoCompartilhadoUsuario.cns}`
                        : item.finalizacao.atendimentoCompartilhadoUsuario.nome"
                    label="Atendimento compartilhado"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.saudeBucal.fornecimentos.join(', ')"
                    label="Fornecimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProcedimentoAdministrativo :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCasoSuspeito :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.racionalidadeSaude.descricao"
                    label="Racionalidade em saúde (Exceto alopatia/convencional)"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.condutas.join(', ')"
                    label="Condutas"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.equipe.descricao"
                    label="Equipe"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <Item
                    :get-value="() => item.finalizacao.turno.nome"
                    label="Turno"
                />
            </rkm-col>

            <rkm-col cols="6">
                <Item
                    :get-value="() => item.finalizacao.atencaoBasicaLocalAtendimento.descricao"
                    label="Local de atendimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.finalizacao.desfecho"
                    label="Desfecho"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import BoxCasoSuspeito from './components/caso-suspeito/Index'
import BoxProcedimentoAdministrativo from './components/procedimento-administrativo/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        BoxCasoSuspeito,
        BoxProcedimentoAdministrativo,
        Item
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>